//
// Copyright (c) 2011-2016 by Curalate, Inc.
//

import searchFilterSetSummaryTemplate from '@legacy-components/filters/search-filter-set-summary.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

    /**
     * Search filter summary component that displays the current state of all search filters and allows users to clear filters
     * @param {boolean} initiallyExpand - whether this collapsable section initially expands or not
     * @param {string[]} excludedKeys - keys in the filter state to not include in the search filter set summary
     *                                 a value with a prefix on this list does not need a label
     */
  curalate.component('searchFilterSetSummary', {
    bindings: {
      initiallyExpand: '<',
      excludedKeys: '<',
    },
    require: {
      searchFilterSet: '^searchFilterSet',
    },
    template: searchFilterSetSummaryTemplate,
    controller: [
      '$scope',
      'SearchFilterService',
      function(
                $scope,
                SearchFilterService,
            ) {
        const self = this;
        let foldingKeys;

        $scope.model = {
          initiallyExpand: !!self.initiallyExpand,
        };

        $scope.model.isKeyLocked = function(categoryKey) {
          return _(self.searchFilterSet.lockedKeys).contains(categoryKey);
        };

        $scope.model.clearFilter = function(categoryKey, optionValue) {
          const foldingKeyWithAlias = _(foldingKeys).find(foldingKey => foldingKey.alias === optionValue);

          const valuesList = foldingKeyWithAlias ? foldingKeyWithAlias.values : [optionValue];
          SearchFilterService.clearFilter(self.searchFilterSet.name, categoryKey, valuesList);
        };

        $scope.model.clearAllFilters = function() {
          SearchFilterService.clearAllFilters(self.searchFilterSet.name);
        };

        this.$onInit = function() {
          const SUMMARY_COMPONENT_NAME = 'searchFilterSummary';

          if (self.searchFilterSet.isSetLoadable) {
            self.isLoading = true;
            self.searchFilterSet.loadingStateObservable.subscribe((isSetLoading) => {
              self.isLoading = isSetLoading;
            });
            self.searchFilterSet.setLoadingState(SUMMARY_COMPONENT_NAME);
          } else {
            self.isLoading = false;
          }

          SearchFilterService.getObservableForFilterSet(self.searchFilterSet.name).subscribe((setUpdate) => {
            $scope.model.setCategories = angular.copy(setUpdate.setCategories);
            $scope.model.activeFiltersCount = setUpdate.filterCount;
            $scope.model.allKeysLocked = _($scope.model.setCategories).every(category => $scope.model.isKeyLocked(category.key));

            self.searchFilterSet.completeLoadingState(SUMMARY_COMPONENT_NAME);
          });

          SearchFilterService.getAliasObservableForFilterSet(self.searchFilterSet.name).subscribe((setUpdate) => {
            foldingKeys = setUpdate.foldingKeys;
          });
        };
      },
    ],
  });
})();
